<form class="row">
  <div class="col-12">
    <div class="input-group">
      <input class="form-control" placeholder="{{placeholder}}" #dpInput [minDate]="minDate" [maxDate]="maxDate" [startDate]="startDate"
             name="dp" ngbDatepicker #datepicker="ngbDatepicker" [firstDayOfWeek]="7" [markDisabled]="markDisabled" (change)="inputChanges()">
      <button class="btn btn-outline-secondary calendar" (click)="datepicker.toggle()" type="button"></button>
    </div>
  </div>
</form>
